
import React from 'react';
import './stopify.scss';

// StopifyNavigator widget wrapper — embeds the tracker as a small floating iframe/button
export default function StopifyWidget() {
  return (
    <div className="stopify-widget" aria-hidden="false">
      {/* Floating button that opens a small iframe modal */}
      <a className="stopify-button" href="https://stopify.co/Q7C8TZ" target="_blank" rel="noreferrer noopener" title="Navigate with Stopify">Navigate</a>
      {/* Non-interactive small iframe preview (hidden on small screens) */}
      <div className="stopify-preview" role="region" aria-label="Stopify preview">
        <iframe src="https://stopify.co/Q7C8TZ" title="Stopify Navigator" loading="lazy" sandbox="allow-forms allow-scripts allow-same-origin" />
      </div>
    </div>
  );
}
